import { render } from "./AppSelfMed.vue?vue&type=template&id=450f9eb5&scoped=true"
const script = {}

import "./AppSelfMed.vue?vue&type=style&index=0&id=450f9eb5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450f9eb5"]])

export default __exports__